import { Imembers } from 'src/Types/module/member/memberTypes';
import { Button } from '@mui/material';
import jsPDF from 'jspdf';
import { useRef, useState } from 'react';
import GlobalLoader from '../SuspenseLoader/GlobalLoader';
import { imgUrl } from 'src/Helpers/utils/Constant';

// import { imgUrl } from "src/Helpers/utils/Constant";

interface Props {
  getDownloadData: () => Promise<{
    total: number;
    data: Imembers[];
  }>;
}
export const getImageBuffer = async (imageUrl: string) => {
  try {
    const response = await fetch(imageUrl, { cache: 'no-cache' });
    if (!response.ok) throw new Error(`Image fetch failed: ${response.status}`);
    const bufferArray = await response.arrayBuffer();
    return new Uint8Array(bufferArray);
  } catch (error) {
    console.error('Error fetching image:', error);
    return null;
  }
};
const PdfGenerator = ({ getDownloadData }: Props) => {
  const [loading, setLoading] = useState(false);

  const cachedHeaderImage = useRef<string | null>(null);

  const fetchAndCacheImage = async (url: string) => {
    if (cachedHeaderImage.current) return cachedHeaderImage.current;
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        cachedHeaderImage.current = reader.result as string;
        resolve(cachedHeaderImage.current);
      };
      reader.readAsDataURL(blob);
    });
  };
  const generatePdf = async () => {
    var doc = new jsPDF('p', 'pt');
    setLoading(true);
    const data = await getDownloadData();

    const ROWS_PER_PAGE = 9;
    const totalPages = Math.ceil(data.total / ROWS_PER_PAGE);

    //header image cash first time
    const headerImage = await fetchAndCacheImage(
      'https://m360ict.s3.ap-south-1.amazonaws.com/uploads/UploadedFiles/Logo/atab3.png'
    );
    for (let page = 1; page <= totalPages; page++) {
      doc
        .setFontSize(10)
        .text(
          'Sattara Center (15th Floor), 30/A, Nayapaltan, VIP Road, Dhaka-1000, Bangladesh',
          280,
          60,
          { align: 'center' }
        );
      doc
        .setFontSize(22)
        .text('Member Directory', 300, 85, { align: 'center' });
      // ✅ Measure text width and draw underline
      const text = 'Member Directory';
      const textWidth = doc.getTextWidth(text);
      const textX = 300 - textWidth / 2; // center align adjustment
      const textY = 85;

      doc
        .setDrawColor(0, 0, 0)
        .line(textX, textY + 5, textX + textWidth, textY + 5);

      doc.setFontSize(7).text(`Total: ${data.total}`, 30, 100);
      doc.setFontSize(7).text(`Date:${new Date().toDateString()}`, 570, 100, {
        align: 'right',
      });

      const startIndex = (page - 1) * ROWS_PER_PAGE;
      const endIndex = Math.min(startIndex + ROWS_PER_PAGE, data.total);
      let j = 0;

      for (let i = startIndex; i < endIndex; i++) {
        doc.addImage(headerImage, 'JPEG', 140, 10, 300, 30);

        const position = 50 + (j + 1) * 80;
        j++;
        if (data.data[i].company_owner_photo) {
          try {
            const imgBuffer = await getImageBuffer(
              imgUrl + '/' + data.data[i].company_owner_photo
            );
            doc.addImage(imgBuffer, 'JPEG', 330, position - 10, 50, 50);
          } catch (error) {
            console.warn(
              'Failed to add image for:',
              data.data[i].company_owner_photo
            );
          }
        }

        // ===== Draw table row borders =====
        const rowX = 20; // left margin
        const rowY = position - 20; // adjust Y
        const rowWidth = 550; // width of table row
        const rowHeight = 80; // height of row
        doc.rect(rowX, rowY, rowWidth, rowHeight); // draw outer row border

        // Optional: draw column separators (6 columns for example)
        const colWidths = [18, 60, 120, 100, 80, 100, 100]; // adjust widths for columns
        let colX = rowX;
        colWidths.forEach((w) => {
          colX += w;
          doc.line(colX, rowY, colX, rowY + rowHeight); // vertical lines
        });

        // ===== Add content inside row =====  //5th column
        // doc.addImage(image, 'JPEG', 330, position - 10, 50, 50);

        doc
          .setFontSize(8)
          .text(`${i + 1}`, 22, position - 10)
          .setFontSize(7)
          .text(`${data.data[i].user_member_id_card_number}`, 40, position - 10)
          .setFontSize(8)
          .setFont('helvetica', 'bold')
          .text(
            `${data.data[i].user_member_company_name}`,
            100,
            position - 10,
            {
              maxWidth: 100,
            }
          )
          .setFont('helvetica', 'normal')
          .text(`${data.data[i].addressline1}`, 100, position - 10 + 18, {
            maxWidth: 110,
          })
          .setFontSize(7) //4th column
          .setFont('helvetica', 'bold')
          .text(`${data.data[i].company_owner_name}\n\n`, 219, position - 10, {
            maxWidth: 90,
          })
          .setFont('helvetica', 'normal')
          .text(
            `${data.data[i].company_owner_designation}`,
            220,
            position - 10 + 15
          ) // 6 th column
          .text(`Tel`, 400, position - 12, {
            maxWidth: 75,
          })
          .text(`:`, 422, position - 12)
          .text(`${data.data[i].cellphone}`, 424, position - 12, {
            maxWidth: 75,
          })
          .text(`Phone`, 400, position)
          .text(`:`, 422, position)
          .text(`${data.data[i].user_member_phone}`, 424, position)
          .text(`Email`, 400, position + 12)
          .text(`:`, 418, position + 12)
          .text(`${data.data[i].user_member_email}`, 420, position + 12, {
            maxWidth: 75,
          });

        doc.setFontSize(7).text(`Page ${page} of ${totalPages}`, 230, 838, {
          align: 'left',
        });
      }

      if (page < totalPages) {
        doc.addPage();
      }
    }

    setLoading(false);
    doc.save('member_list.pdf');
  };

  return (
    <>
      {loading ? (
        <GlobalLoader />
      ) : (
        <Button
          onClick={generatePdf}
          variant='outlined'
          size='small'
          sx={{ py: 1 }}
        >
          Download pdf
        </Button>
      )}
    </>
  );
};

export default PdfGenerator;
